import BrandProfile from './BrandProfile.View';

export default BrandProfile;
